import { get, post } from 'common/utils/xhr';
import DraftStore from 'launch/stores/DraftStore';
import DraftStepStore from 'launch/stores/DraftStepStore';
import BriefStore from 'launch/stores/BriefStore';
import UrlStore from 'launch/stores/UrlStore';
import history from 'common/utils/browserhistory';
import { trackEvent } from '@99designs/common/utils/platform';
import { STARTED_LAUNCH, VIEWED_LAUNCH_STEP } from 'launch/consts/trackEventNames';
import humps from 'humps';

export function clearStatus(ctx, payload) {
    ctx.dispatch('CLEAR_STATUS', payload);
}

export function toggleColor(ctx, payload) {
    ctx.dispatch('TOGGLE_COLOR', payload);
}

export function toggleDesign(ctx, payload) {
    ctx.dispatch('TOGGLE_DESIGN', payload);
}

export function updateCustomColors(ctx, payload) {
    ctx.dispatch('UPDATE_CUSTOM_COLORS', payload);
}

export function prefillBrief(ctx) {
    // Opt out the auto saving for prefill field
    // Save it with other prefill fields together
    let data = { prefill: 'yes' };
    const briefData = ctx.getStore(BriefStore).briefData;
    const previousDraftData = ctx.getStore(DraftStore).previousDraftData;

    Object.keys(previousDraftData).map(key => {
        if (!briefData[key]) {
            data[key] = previousDraftData[key];
        }
    });

    ctx.dispatch('UPDATE_BRIEF', data);
    return ctx.executeAction(saveDraft, { data });
}

export function resetPrefilledFields(ctx) {
    let data = { prefill: 'no' };
    const briefData = ctx.getStore(BriefStore).briefData;
    const previousDraftData = ctx.getStore(DraftStore).previousDraftData;

    Object.keys(previousDraftData).map(key => {
        if (briefData[key] === previousDraftData[key]) {
            data[key] = null;
        }
    });

    ctx.dispatch('UPDATE_BRIEF', data);
    return ctx.executeAction(saveDraft, { data });
}

export function saveDraft(ctx, payload = { options: {}, data: {} }) {
    let data = {
        ...humps.decamelizeKeys(payload.data, { seperator: '_' }),
        step: ctx.getStore(DraftStepStore).getCurrentStepId(),
    };

    ctx.dispatch('SAVE_DRAFT_STARTED');
    let xhr = post(urlFor(ctx, 'updateDraft'), data);

    return new Promise((resolve, reject) => {
        xhr.end((error, res) => {
            if (error) {
                ctx.dispatch('SAVE_DRAFT_FAILURE', { error });
                reject({ error });
            } else {
                ctx.dispatch('SAVE_DRAFT_SUCCESS', {
                    ...res.body,
                    ...payload.options,
                });
                resolve();
            }
        });
    });
}

export function transitionToStep(ctx, step) {
    const contestsSteps = ['contestsBrief', 'contestsDetails', 'contestsPayment'];

    if (contestsSteps.indexOf(step) !== -1) {
        redirectTo(urlFor(ctx, step));
    } else {
        const url = ctx.getStore(DraftStepStore).urlForStep(step);
        history.push(url);
    }

    return Promise.resolve();
}

export function transitionToNextStep(ctx, payload = {}) {
    function transition() {
        const nextStep = ctx.getStore(DraftStepStore).getNextStep();

        if (nextStep) {
            return ctx.executeAction(transitionToStep, nextStep);
        } else {
            return Promise.resolve();
        }
    }

    if (payload.saveAction) {
        return ctx.executeAction(payload.saveAction, payload).then(transition);
    } else {
        return transition();
    }
}

export function fetchDraft(ctx, { step }) {
    const xhr = get(urlFor(ctx, 'fetchDraft')).query({ step });

    return new Promise((resolve, reject) => {
        xhr.end((error, res) => {
            if (error) {
                return reject(error);
            }

            ctx.dispatch('LOAD_DRAFT_DATA', res.body);
            return resolve();
        });
    });
}

export function loadDraftData(ctx, payload, done) {
    ctx.dispatch('LOAD_DRAFT_DATA', payload);
    done();
}

export function loadDraftSteps(ctx, payload) {
    ctx.dispatch('LOAD_DRAFT_STEPS', payload);

    const { currentStep } = ctx.getStore(DraftStepStore);
    return ctx.executeAction(updateDraftStep, { step: currentStep });
}

export function updateDraftStep(ctx, { step, params }) {
    ctx.dispatch('UPDATE_DRAFT_STEP', step);

    return ctx.executeAction(fetchDraft, { step }).then(() => {
        const category = ctx.getStore(DraftStore).categoryKey;
        const stepStore = ctx.getStore(DraftStepStore);

        if (stepStore.isFirstStep()) {
            trackEvent(STARTED_LAUNCH, {
                category,
                ...params,
            });
        }

        trackEvent(VIEWED_LAUNCH_STEP, {
            category,
            step,
            ...params,
        });
    });
}

function urlFor(ctx, key) {
    return ctx.getStore(UrlStore).urlFor(key);
}

function redirectTo(url) {
    window.location.href = url;
}
